import Vue from "vue";
import Router from "vue-router";
import {getOS} from "./utils/MobileGlobal";
// import Home from "./pages/Home";
// import Travel from "./pages/Travel/write";
// import Preview from "./pages/Travel/preview";
// import NewTravel from "./pages/Travel/new-travel";
// import TravelList from "./pages/Travel/travel-list";
// import TravelAttr from "./pages/Travel/travel-attribute";
// import PersonInfo from "./pages/personal/person-info";
// import SaveSuccess from "./pages/Travel/save-success";
// import Login from "./pages/login";
// import Detail from './pages/Travel/travel-detail'
// import RequestPath from "./utils/RequestPath";
// import MyTravel from "./pages/personal/my-travel";
// import Play from './pages/play';
Vue.use(Router);
let platformFlag = getOS();

const webRoutes =  [
    {
      path: "/",
      name: "home",
      component: () => import("./pages/Home"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/traveling/:id",
      name: "traveling",
      props: true,
      component: () => import("./pages/Travel/write"),
      meta: {
        showWriteBall: false,
        requireAuth: true
      }
    },
    {
      path: "/preview/:id",
      name: "preview",
      component: () => import("./pages/Travel/preview"),
      meta: {
        showWriteBall: false,
        requireAuth: true
      }
    },
    {
      path: "/detail/:id",
      name: "detail",
      props: true,
      component: () => import("./pages/Travel/travel-detail"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/newTravel",
      name: "newTravel",
      component: () => import("./pages/Travel/new-travel"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/travelList",
      name: "travelList",
      component: () => import("./pages/Travel/travel-list"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/travelAttr",
      name: "travelAttr",
      component: () => import("./pages/Travel/travel-attribute"),
      meta: {
        showWriteBall: false,
        requireAuth: true
      }
    },
    {
      path: "/personInfo",
      name: "personInfo",
      component: () => import("./pages/personal/person-info"),
      meta: {
        showWriteBall: false,
        requireAuth: true
      }
    },
    {
      path: "/success",
      name: "success",
      component: () => import("./pages/Travel/save-success"),
      meta: {
        showWriteBall: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./pages/login"),
      meta: {
        showWriteBall: false
      }
    },
    {
      path: "/mine/:type",
      name: "mine",
      component: () => import("./pages/personal/my-travel"),
      props: true,
      meta: {
        showWriteBall: true,
        requireAuth: true
      }
    },
    {
      path: "/minelog/:type",
      name: "minelog",
      component: () => import("./pages/login"),
      props: true,
      meta: {
        showWriteBall: false
      }
    },
    {
      path: "/play",
      name: "play",
      component: () => import("./pages/play"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/message",
      name: "message",
      component: () => import("./pages/message"),
      meta: {
        showWriteBall: true,
        requireAuth: true
      }
    },
    {
      path: "/protocal/serve",
      name: "serveProtocal",
      component: () => import("./pages/protocal/serve"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/protocal/privacy",
      name: "privacyProtocal",
      component: () => import("./pages/protocal/privacy"),
      meta: {
        showWriteBall: true
      }
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./pages/About"),
      meta: {
        showWriteBall: false
      }
    }
];
//移动端路由(使用vant)
const mobileRoutesPro = [
  {
    path: "/",
    name: "home",
    component: () => import("./mobile_pro/Home")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/mobile_pro/Login")
  },
  {
    path: "/regist",
    name: "regist",
    component: () => import("@/mobile_pro/Regist")
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import("@/mobile_pro/ForgetPassword")
  },
  {
    path: "/person",
    name: "person",
    component: () => import("@/mobile_pro/Person")
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("@/mobile_pro/Activity")
  },
  //最新游记列表页面
  {
    path: "/newTravelList",
    name: "newTravelList",
    component: () => import("@/mobile_pro/NewTravelList")
  },
  {
    path: "/searchList",
    name: "searchList",
    component: () => import("@/mobile_pro/SearchList")
  },
  {
    path: "/travelDetail/:id",
    name: "travelDetail",
    component: () => import("@/mobile_pro/TravelDetail")
  }
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: platformFlag === 'PC' ? webRoutes:mobileRoutesPro,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});
